// On-demand loading of heavy libraries with requestIdleCallback
let heavyLibsLoaded = false;

const loadHeavyLibraries = () => {
  if (heavyLibsLoaded) return;
  heavyLibsLoaded = true;

  // Use requestIdleCallback to avoid blocking the main thread
  const loadLib = (importFn) => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => importFn(), { timeout: 2000 });
    } else {
      setTimeout(() => importFn(), 1);
    }
  };

  // Load jquery-match-height
  loadLib(() => {
    import(/* webpackChunkName: "match-height" */ "jquery-match-height")
      .then(() => {
        if (typeof $ !== "undefined" && $(".match-height").length) {
          $(".match-height").matchHeight();
        }
      })
      .catch(() => {});
  });

  // Load jquery-parallax
  loadLib(() => {
    import(/* webpackChunkName: "parallax" */ "jquery-parallax.js")
      .then(() => {
        if (typeof $ !== "undefined" && $(".parallax").length) {
          $(".parallax").parallax();
        }
      })
      .catch(() => {});
  });

  // Load Flickity module
  loadLib(() => {
    import(/* webpackChunkName: "flickity" */ "./modules/flickity.js")
      .then(async (flickityModule) => {
        await flickityModule.initFlickity();
        if (typeof $ !== "undefined" && $(".carousel").length) {
          $(".carousel").each(async function () {
            await flickityModule.createFlickity(this, {
              cellAlign: "left",
              contain: true,
              wrapAround: true,
            });
          });
        }
      })
      .catch(() => {});
  });

  // Load imagesloaded
  loadLib(() => {
    import(/* webpackChunkName: "imagesloaded" */ "imagesloaded")
      .then((imagesLoaded) => {
        window.imagesLoaded = imagesLoaded.default;
      })
      .catch(() => {});
  });

  // Load unidragger
  loadLib(() => {
    import(/* webpackChunkName: "unidragger" */ "unidragger")
      .then((unidragger) => {
        window.unidragger = unidragger.default;
      })
      .catch(() => {});
  });
};

// Optimized event handler
const events = ["click", "scroll", "keydown", "touchstart"];
const eventHandler = () => {
  loadHeavyLibraries();
  events.forEach((event) => document.removeEventListener(event, eventHandler));
};
events.forEach((event) => {
  document.addEventListener(event, eventHandler, { passive: true });
});

// Fallback: load after page load + 5 seconds
if (document.readyState === "complete") {
  setTimeout(loadHeavyLibraries, 5000);
} else {
  window.addEventListener("load", () => setTimeout(loadHeavyLibraries, 5000));
}

// Export for manual loading if needed
window.loadHeavyLibraries = loadHeavyLibraries;
